module.exports = __webpack_public_path__ + "static/img/jjLogo.180581b2.png";